import { useCallback, useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** Whether the user asked for reduced motion, kept live as it changes. */
export function useReducedMotion(): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const mql = window.matchMedia(QUERY);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false
  );
}

/**
 * True when a browser is being driven by automation (`navigator.webdriver`:
 * Storybook's Vitest run, Playwright E2E, Chromatic). Tab motion is skipped
 * there: those tools check a story the instant it ends, and a journey that
 * ends on a tab switch was scanned by axe mid-motion, where half-faded text
 * or a label ahead of its pill fails colour-contrast. A real browser never
 * sets the flag.
 */
export function isAutomated(): boolean {
  return typeof navigator !== 'undefined' && navigator.webdriver === true;
}
